import { Button as MaterialButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useContext, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Role } from '../api/user/Role';
import { Listing } from '../components/Pages/Listing';
import BaseLayout from '../components/layout/base-layout';
import GoalsList from '../components/lists/goals-list';
import GoalsTable from '../components/tables/goals-table';
import { GoalsProvider, useGoalsContext } from '../contexts/goals-context';
import { UserContext } from '../contexts/user-context';
import { Pages } from '../router/constants';
import { ProtectedRouteProps } from '../router/type';
import { encodeQuery, isMobile } from '../utils/functions';
import { CLASS_TRACKING } from '../utils/tracking_class';

function Goals({ user }: ProtectedRouteProps) {
  const { hasAccessToAction, hasRole } = useContext(UserContext);
  const location = useLocation();
  const { filters, ventures } = useGoalsContext();

  const currentPath = useMemo(
    () => `${location.pathname}${location.search}`,
    [location],
  );

  return (
    <BaseLayout user={user} fullWidth hiddenFooter={isMobile()}>
      <Listing
        title='Goals'
        actions={[
          {
            key: 'new-goal',
            label: 'New Goal',
            hidden: !hasAccessToAction('goal.create'),
            component: (
              <MaterialButton
                className={CLASS_TRACKING.ENTITY_ACTION}
                data-testid='button-new-goal'
                component={Link}
                to={{
                  pathname: Pages.NEW_GOAL,
                  state: {
                    prevPath: currentPath,
                  },
                  search: filters.venture
                    ? `?venture=${encodeQuery({
                        id: filters.venture.id,
                        ventureName: filters.venture.ventureName,
                      })}`
                    : '',
                }}
                startIcon={<AddIcon />}
                variant='contained'
                key='button-new-goal'
                disabled={
                  !ventures.length &&
                  !hasRole(Role.Admin) &&
                  !hasRole(Role.Manager)
                }
                color='primary'>
                Goal
              </MaterialButton>
            ),
          },
        ]}>
        {isMobile() ? <GoalsList /> : <GoalsTable />}
      </Listing>
    </BaseLayout>
  );
}

function GoalsPage(props: ProtectedRouteProps) {
  return (
    <GoalsProvider>
      <Goals {...props} />
    </GoalsProvider>
  );
}

export default GoalsPage;
